import "./Home.module.css";
import ExecutiveNavigation from "@/reusable_sections/Header";
import ArchitectingGenerationalWealth from "./sections/ArchitectingGenerationalWealth";
import ClientArchetypes from "./sections/ClientArchetypes";
import StrategicWealthPillars from "./sections/StrategicWealthPillars";
import TheCarolinasAdvantage from "./sections/TheCarolinasAdvantage";
import SuccessBlueprints from "./sections/SuccessBlueprints";
import ConfidentialConsultation from "./sections/ConfidentialConsultation";
import LegacyFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <ExecutiveNavigation />
      <ArchitectingGenerationalWealth />
      <ClientArchetypes />
      <StrategicWealthPillars />
      <TheCarolinasAdvantage />
      <SuccessBlueprints />
      <ConfidentialConsultation />
      <LegacyFooter />
    </div>;
}